import { faAddressBook } from '@fortawesome/pro-solid-svg-icons/faAddressBook';
import { faAlignCenter } from '@fortawesome/pro-solid-svg-icons/faAlignCenter';
import { faAlignJustify } from '@fortawesome/pro-solid-svg-icons/faAlignJustify';
import { faAlignLeft } from '@fortawesome/pro-solid-svg-icons/faAlignLeft';
import { faAlignRight } from '@fortawesome/pro-solid-svg-icons/faAlignRight';
import { faAnchor } from '@fortawesome/pro-solid-svg-icons/faAnchor';
import { faArchive } from '@fortawesome/pro-solid-svg-icons/faArchive';
import { faArrowAltToLeft } from '@fortawesome/pro-solid-svg-icons/faArrowAltToLeft';
import { faArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import {
  faArrowDownAZ,
  faBorderAll,
  faBullseyePointer,
  faClockRotateLeft,
  faFolderMagnifyingGlass,
  faGrid2Plus,
  faLoader,
  faPenToSquare,
  faSquareDashedCirclePlus,
} from '@fortawesome/pro-solid-svg-icons';
import { faArrowDownLeftAndArrowUpRightToCenter } from '@fortawesome/pro-solid-svg-icons/faArrowDownLeftAndArrowUpRightToCenter';
import { faArrowDownArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowDownArrowUp';
import { faArrowDownToLine } from '@fortawesome/pro-solid-svg-icons/faArrowDownToLine';
import { faArrowDownWideShort } from '@fortawesome/pro-solid-svg-icons/faArrowDownWideShort';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowLeftFromLine } from '@fortawesome/pro-solid-svg-icons/faArrowLeftFromLine';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faArrowRightFromBracket } from '@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket';
import { faArrowRightToBracket } from '@fortawesome/pro-solid-svg-icons/faArrowRightToBracket';
import { faArrowToLeft } from '@fortawesome/pro-solid-svg-icons/faArrowToLeft';
import { faArrowToRight } from '@fortawesome/pro-solid-svg-icons/faArrowToRight';
import { faArrowToTop } from '@fortawesome/pro-solid-svg-icons/faArrowToTop';
import { faArrowTurnDown } from '@fortawesome/pro-solid-svg-icons/faArrowTurnDown';
import { faArrowTurnDownLeft } from '@fortawesome/pro-solid-svg-icons/faArrowTurnDownLeft';
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faArrowUpArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowUpArrowDown';
import { faArrowUpFromBracket } from '@fortawesome/pro-solid-svg-icons/faArrowUpFromBracket';
import { faArrowUpRightAndArrowDownLeftFromCenter } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightAndArrowDownLeftFromCenter';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import { faArrowUpToLine } from '@fortawesome/pro-solid-svg-icons/faArrowUpToLine';
import { faArrows } from '@fortawesome/pro-solid-svg-icons/faArrows';
import { faArrowsAltV } from '@fortawesome/pro-solid-svg-icons/faArrowsAltV';
import { faArrowsFromDottedLine } from '@fortawesome/pro-solid-svg-icons/faArrowsFromDottedLine';
import { faArrowsLeftRightToLine } from '@fortawesome/pro-solid-svg-icons/faArrowsLeftRightToLine';
import { faArrowsToLine } from '@fortawesome/pro-solid-svg-icons/faArrowsToLine';
import { faAsterisk } from '@fortawesome/pro-solid-svg-icons/faAsterisk';
import { faAt } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faBackspace } from '@fortawesome/pro-solid-svg-icons/faBackspace';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBarsSort } from '@fortawesome/pro-solid-svg-icons/faBarsSort';
import { faBarsStaggered } from '@fortawesome/pro-solid-svg-icons/faBarsStaggered';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { faBold } from '@fortawesome/pro-solid-svg-icons/faBold';
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt';
import { faBookAtlas } from '@fortawesome/pro-solid-svg-icons/faBookAtlas';
import { faBookBookmark } from '@fortawesome/pro-solid-svg-icons/faBookBookmark';
import { faBookOpen } from '@fortawesome/pro-solid-svg-icons/faBookOpen';
import { faBookmark } from '@fortawesome/pro-solid-svg-icons/faBookmark';
import { faBorderOuter } from '@fortawesome/pro-solid-svg-icons/faBorderOuter';
import { faBoxArchive } from '@fortawesome/pro-solid-svg-icons/faBoxArchive';
import { faBoxOpen } from '@fortawesome/pro-solid-svg-icons/faBoxOpen';
import { faBrowser } from '@fortawesome/pro-solid-svg-icons/faBrowser';
import { faBrowsers } from '@fortawesome/pro-solid-svg-icons/faBrowsers';
import { faBrush } from '@fortawesome/pro-solid-svg-icons/faBrush';
import { faBug } from '@fortawesome/pro-solid-svg-icons/faBug';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar';
import { faCalculator } from '@fortawesome/pro-solid-svg-icons/faCalculator';
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt';
import { faCalendarCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCalendarCircleExclamation';
import { faCalendarDay } from '@fortawesome/pro-solid-svg-icons/faCalendarDay';
import { faCalendarRange } from '@fortawesome/pro-solid-svg-icons/faCalendarRange';
import { faCalendarStar } from '@fortawesome/pro-solid-svg-icons/faCalendarStar';
import { faCalendarWeek } from '@fortawesome/pro-solid-svg-icons/faCalendarWeek';
import { faCamera } from '@fortawesome/pro-solid-svg-icons/faCamera';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faChartTreeMap } from '@fortawesome/pro-solid-svg-icons/faChartTreeMap';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faCircleHalfStroke } from '@fortawesome/pro-solid-svg-icons/faCircleHalfStroke';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { faCircleUser } from '@fortawesome/pro-solid-svg-icons/faCircleUser';
import { faClipboard } from '@fortawesome/pro-solid-svg-icons/faClipboard';
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faClone } from '@fortawesome/pro-solid-svg-icons/faClone';
import { faCloudArrowDown } from '@fortawesome/pro-solid-svg-icons/faCloudArrowDown';
import { faCloudArrowUp } from '@fortawesome/pro-solid-svg-icons/faCloudArrowUp';
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { faColumns3 } from '@fortawesome/pro-solid-svg-icons/faColumns3';
import { faCommentAltPlus } from '@fortawesome/pro-solid-svg-icons/faCommentAltPlus';
import { faCommentPlus } from '@fortawesome/pro-solid-svg-icons/faCommentPlus';
import { faCropSimple } from '@fortawesome/pro-solid-svg-icons/faCropSimple';
import { faCrown } from '@fortawesome/pro-solid-svg-icons/faCrown';
import { faDiagramSubtask } from '@fortawesome/pro-solid-svg-icons/faDiagramSubtask';
import { faDiamond } from '@fortawesome/pro-solid-svg-icons/faDiamond';
import { faDrawCircle } from '@fortawesome/pro-solid-svg-icons/faDrawCircle';
import { faDrawPolygon } from '@fortawesome/pro-solid-svg-icons/faDrawPolygon';
import { faDrawSquare } from '@fortawesome/pro-solid-svg-icons/faDrawSquare';
import { faEdit } from '@fortawesome/pro-solid-svg-icons/faEdit';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faEnvelopeCircleCheck } from '@fortawesome/pro-solid-svg-icons/faEnvelopeCircleCheck';
import { faEnvelopeOpen } from '@fortawesome/pro-solid-svg-icons/faEnvelopeOpen';
import { faExpand } from '@fortawesome/pro-solid-svg-icons/faExpand';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons/faExternalLink';
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faFileChartPie } from '@fortawesome/pro-solid-svg-icons/faFileChartPie';
import { faFileCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faFileCircleExclamation';
import { faFileCsv } from '@fortawesome/pro-solid-svg-icons/faFileCsv';
import { faFileDashedLine } from '@fortawesome/pro-solid-svg-icons/faFileDashedLine';
import { faFileExcel } from '@fortawesome/pro-solid-svg-icons/faFileExcel';
import { faFileExport } from '@fortawesome/pro-solid-svg-icons/faFileExport';
import { faFileImport } from '@fortawesome/pro-solid-svg-icons/faFileImport';
import { faFileImage } from '@fortawesome/pro-solid-svg-icons/faFileImage';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons/faFileLines';
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faFilePowerpoint } from '@fortawesome/pro-solid-svg-icons/faFilePowerpoint';
import { faFileSpreadsheet } from '@fortawesome/pro-solid-svg-icons/faFileSpreadsheet';
import { faFileText } from '@fortawesome/pro-solid-svg-icons/faFileText';
import { faFileWord } from '@fortawesome/pro-solid-svg-icons/faFileWord';
import { faFiles } from '@fortawesome/pro-solid-svg-icons/faFiles';
import { faFillDrip } from '@fortawesome/pro-solid-svg-icons/faFillDrip';
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter';
import { faFilterSlash } from '@fortawesome/pro-solid-svg-icons/faFilterSlash';
import { faFlag } from '@fortawesome/pro-solid-svg-icons/faFlag';
import { faFlask } from '@fortawesome/pro-solid-svg-icons/faFlask';
import { faFolder } from '@fortawesome/pro-solid-svg-icons/faFolder';
import { faFolderArrowDown } from '@fortawesome/pro-solid-svg-icons/faFolderArrowDown';
import { faFolderArrowUp } from '@fortawesome/pro-solid-svg-icons/faFolderArrowUp';
import { faFolderGear } from '@fortawesome/pro-solid-svg-icons/faFolderGear';
import { faFolderOpen } from '@fortawesome/pro-solid-svg-icons/faFolderOpen';
import { faFolderPlus } from '@fortawesome/pro-solid-svg-icons/faFolderPlus';
import { faFolders } from '@fortawesome/pro-solid-svg-icons/faFolders';
import { faFont } from '@fortawesome/pro-solid-svg-icons/faFont';
import { faFontCase } from '@fortawesome/pro-solid-svg-icons/faFontCase';
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import { faGearComplexCode } from '@fortawesome/pro-solid-svg-icons/faGearComplexCode';
import { faGlobePointer } from '@fortawesome/pro-solid-svg-icons/faGlobePointer';
import { faGrid } from '@fortawesome/pro-solid-svg-icons/faGrid';
import { faGripDots } from '@fortawesome/pro-solid-svg-icons/faGripDots';
import { faGripLinesVertical } from '@fortawesome/pro-solid-svg-icons/faGripLinesVertical';
import { faGripVertical } from '@fortawesome/pro-solid-svg-icons/faGripVertical';
import { faHandshake } from '@fortawesome/pro-solid-svg-icons/faHandshake';
import { faHand } from '@fortawesome/pro-solid-svg-icons/faHand';
import { faHashtag } from '@fortawesome/pro-solid-svg-icons/faHashtag';
import { faHeading } from '@fortawesome/pro-solid-svg-icons/faHeading';
import { faHexagonExclamation } from '@fortawesome/pro-solid-svg-icons/faHexagonExclamation';
import { faHighlighterLine } from '@fortawesome/pro-solid-svg-icons/faHighlighterLine';
import { faICursor } from '@fortawesome/pro-solid-svg-icons/faICursor';
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage';
import { faIndent } from '@fortawesome/pro-solid-svg-icons/faIndent';
import { faInfo } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faInputText } from '@fortawesome/pro-solid-svg-icons/faInputText';
import { faItalic } from '@fortawesome/pro-solid-svg-icons/faItalic';
import { faLayerGroup } from '@fortawesome/pro-solid-svg-icons/faLayerGroup';
import { faLayerPlus } from '@fortawesome/pro-solid-svg-icons/faLayerPlus';
import { faLineColumns } from '@fortawesome/pro-solid-svg-icons/faLineColumns';
import { faLineHeight } from '@fortawesome/pro-solid-svg-icons/faLineHeight';
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faLinkSimple } from '@fortawesome/pro-solid-svg-icons/faLinkSimple';
import { faLinkSimpleSlash } from '@fortawesome/pro-solid-svg-icons/faLinkSimpleSlash';
import { faListOl } from '@fortawesome/pro-solid-svg-icons/faListOl';
import { faListUl } from '@fortawesome/pro-solid-svg-icons/faListUl';
import { faListTree } from '@fortawesome/pro-solid-svg-icons/faListTree';
import { faLocationPen } from '@fortawesome/pro-solid-svg-icons/faLocationPen';
import { faLocationPinLock } from '@fortawesome/pro-solid-svg-icons/faLocationPinLock';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faLongArrowAltLeft } from '@fortawesome/pro-solid-svg-icons/faLongArrowAltLeft';
import { faLongArrowAltRight } from '@fortawesome/pro-solid-svg-icons/faLongArrowAltRight';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faMagnifyingGlassMinus } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassMinus';
import { faMagnifyingGlassPlus } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassPlus';
import { faMapMarker } from '@fortawesome/pro-solid-svg-icons/faMapMarker';
import { faMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faMemo } from '@fortawesome/pro-solid-svg-icons/faMemo';
import { faMemoCircleInfo } from '@fortawesome/pro-solid-svg-icons/faMemoCircleInfo';
import { faMessageCaptions } from '@fortawesome/pro-solid-svg-icons/faMessageCaptions';
import { faMicrochipAi } from '@fortawesome/pro-solid-svg-icons/faMicrochipAi';
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';
import { faMinusCircle } from '@fortawesome/pro-solid-svg-icons/faMinusCircle';
import { faMousePointer } from '@fortawesome/pro-solid-svg-icons/faMousePointer';
import { faObjectsAlignLeft } from '@fortawesome/pro-solid-svg-icons/faObjectsAlignLeft';
import { faObjectsAlignCenterHorizontal } from '@fortawesome/pro-solid-svg-icons/faObjectsAlignCenterHorizontal';
import { faObjectsAlignRight } from '@fortawesome/pro-solid-svg-icons/faObjectsAlignRight';
import { faObjectsAlignTop } from '@fortawesome/pro-solid-svg-icons/faObjectsAlignTop';
import { faObjectsAlignCenterVertical } from '@fortawesome/pro-solid-svg-icons/faObjectsAlignCenterVertical';
import { faObjectsAlignBottom } from '@fortawesome/pro-solid-svg-icons/faObjectsAlignBottom';
import { faDistributeSpacingHorizontal } from '@fortawesome/pro-solid-svg-icons/faDistributeSpacingHorizontal';
import { faDistributeSpacingVertical } from '@fortawesome/pro-solid-svg-icons/faDistributeSpacingVertical';
import { faOutdent } from '@fortawesome/pro-solid-svg-icons/faOutdent';
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons/faPaperclip';
import { faParagraph } from '@fortawesome/pro-solid-svg-icons/faParagraph';
import { faPauseCircle } from '@fortawesome/pro-solid-svg-icons/faPauseCircle';
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen';
import { faPenField } from '@fortawesome/pro-solid-svg-icons/faPenField';
import { faPenSlash } from '@fortawesome/pro-solid-svg-icons/faPenSlash';
import { faPlaneArrival } from '@fortawesome/pro-solid-svg-icons/faPlaneArrival';
import { faPlaneDeparture } from '@fortawesome/pro-solid-svg-icons/faPlaneDeparture';
import { faPlaneUp } from '@fortawesome/pro-solid-svg-icons/faPlaneUp';
import { faPlaneUpSlash } from '@fortawesome/pro-solid-svg-icons/faPlaneUpSlash';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faPlayCircle } from '@fortawesome/pro-solid-svg-icons/faPlayCircle';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import { faPresentation } from '@fortawesome/pro-solid-svg-icons/faPresentation';
import { faPrint } from '@fortawesome/pro-solid-svg-icons/faPrint';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons/faQuestion';
import { faRabbitRunning } from '@fortawesome/pro-solid-svg-icons/faRabbitRunning';
import { faRectangle } from '@fortawesome/pro-solid-svg-icons/faRectangle';
import { faRepeat } from '@fortawesome/pro-solid-svg-icons/faRepeat';
import { faReply } from '@fortawesome/pro-solid-svg-icons/faReply';
import { faRotate } from '@fortawesome/pro-solid-svg-icons/faRotate';
import { faRotateLeft } from '@fortawesome/pro-solid-svg-icons/faRotateLeft';
import { faRotateRight } from '@fortawesome/pro-solid-svg-icons/faRotateRight';
import { faRuler } from '@fortawesome/pro-solid-svg-icons/faRuler';
import { faSave } from '@fortawesome/pro-solid-svg-icons/faSave';
import { faSatellite } from '@fortawesome/pro-solid-svg-icons/faSatellite';
import { faScribble } from '@fortawesome/pro-solid-svg-icons/faScribble';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faSearchMinus } from '@fortawesome/pro-solid-svg-icons/faSearchMinus';
import { faSearchPlus } from '@fortawesome/pro-solid-svg-icons/faSearchPlus';
import { faShapes } from '@fortawesome/pro-solid-svg-icons/faShapes';
import { faSidebar } from '@fortawesome/pro-solid-svg-icons/faSidebar';
import { faSignal } from '@fortawesome/pro-solid-svg-icons/faSignal';
import { faSignal1 } from '@fortawesome/pro-solid-svg-icons/faSignal1';
import { faSignal2 } from '@fortawesome/pro-solid-svg-icons/faSignal2';
import { faSignal3 } from '@fortawesome/pro-solid-svg-icons/faSignal3';
import { faSignal4 } from '@fortawesome/pro-solid-svg-icons/faSignal4';
import { faSignalSlash } from '@fortawesome/pro-solid-svg-icons/faSignalSlash';
import { faSignalStream } from '@fortawesome/pro-solid-svg-icons/faSignalStream';
import { faSortAlt } from '@fortawesome/pro-solid-svg-icons/faSortAlt';
import { faSortAmountDown } from '@fortawesome/pro-solid-svg-icons/faSortAmountDown';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import { faSquare } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import { faSquareDashed } from '@fortawesome/pro-solid-svg-icons/faSquareDashed';
import { faSquarePlus } from '@fortawesome/pro-solid-svg-icons/faSquarePlus';
import { faSquareQuestion } from '@fortawesome/pro-solid-svg-icons/faSquareQuestion';
import { faStamp } from '@fortawesome/pro-solid-svg-icons/faStamp';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStarHalfAlt } from '@fortawesome/pro-solid-svg-icons/faStarHalfAlt';
import { faStrikethrough } from '@fortawesome/pro-solid-svg-icons/faStrikethrough';
import { faSwap } from '@fortawesome/pro-solid-svg-icons/faSwap';
import { faTable } from '@fortawesome/pro-solid-svg-icons/faTable';
import { faTableCells } from '@fortawesome/pro-solid-svg-icons/faTableCells';
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { faTasks } from '@fortawesome/pro-solid-svg-icons/faTasks';
import { faText } from '@fortawesome/pro-solid-svg-icons/faText';
import { faTextSize } from '@fortawesome/pro-solid-svg-icons/faTextSize';
import { faTextSlash } from '@fortawesome/pro-solid-svg-icons/faTextSlash';
import { faThLarge } from '@fortawesome/pro-solid-svg-icons/faThLarge';
import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import { faThumbtack } from '@fortawesome/pro-solid-svg-icons/faThumbtack';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { faToggleOn } from '@fortawesome/pro-solid-svg-icons/faToggleOn';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faUnderline } from '@fortawesome/pro-solid-svg-icons/faUnderline';
import { faUnlink } from '@fortawesome/pro-solid-svg-icons/faUnlink';
import { faUnlock } from '@fortawesome/pro-solid-svg-icons/faUnlock';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUserCircle } from '@fortawesome/pro-solid-svg-icons/faUserCircle';
import { faUserEdit } from '@fortawesome/pro-solid-svg-icons/faUserEdit';
import { faUserGear } from '@fortawesome/pro-solid-svg-icons/faUserGear';
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons/faUserPlus';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faUsersCog } from '@fortawesome/pro-solid-svg-icons/faUsersCog';
import { faWandMagicSparkles } from '@fortawesome/pro-solid-svg-icons/faWandMagicSparkles';
import { faWaveSine } from '@fortawesome/pro-solid-svg-icons/faWaveSine';
import { faWaveformLines } from '@fortawesome/pro-solid-svg-icons/faWaveformLines';
import { faWindowMaximize } from '@fortawesome/pro-solid-svg-icons/faWindowMaximize';
import { faWrench } from '@fortawesome/pro-solid-svg-icons/faWrench';
import { faHouse } from '@fortawesome/pro-solid-svg-icons/faHouse';
import { faCode } from '@fortawesome/pro-solid-svg-icons/faCode';
import { faArrowsToCircle } from '@fortawesome/pro-solid-svg-icons/faArrowsToCircle';

// prettier-ignore
const FA_SUPPORTED_ICONS = {
  'address-book': faAddressBook,
  'align-center': faAlignCenter,
  'align-justify': faAlignJustify,
  'align-left': faAlignLeft,
  'align-right': faAlignRight,
  anchor: faAnchor,
  archive: faArchive,
  'arrow-alt-to-left': faArrowAltToLeft,
  'arrow-down-a-z': faArrowDownAZ,
  'arrow-down-to-line': faArrowDownToLine,
  'arrow-down-wide-short': faArrowDownWideShort,
  'arrow-down-left-and-arrow-up-right-to-center': faArrowDownLeftAndArrowUpRightToCenter,
  'arrow-down': faArrowDown,
  'arrow-down-arrow-up': faArrowDownArrowUp,
  'arrow-left-from-line': faArrowLeftFromLine,
  'arrow-left': faArrowLeft,
  'arrow-right-from-bracket': faArrowRightFromBracket,
  'arrow-right-to-bracket': faArrowRightToBracket,
  'arrow-right': faArrowRight,
  'arrow-to-left': faArrowToLeft,
  'arrow-to-right': faArrowToRight,
  'arrow-to-top': faArrowToTop,
  'arrow-turn-down': faArrowTurnDown,
  'arrow-turn-down-left': faArrowTurnDownLeft,
  'arrow-up-arrow-down': faArrowUpArrowDown,
  'arrow-up-from-bracket': faArrowUpFromBracket,
  'arrow-up-right-and-arrow-down-left-from-center': faArrowUpRightAndArrowDownLeftFromCenter,
  'arrow-up-right-from-square': faArrowUpRightFromSquare,
  'arrow-up-to-line': faArrowUpToLine,
  'arrow-up': faArrowUp,
  'arrows-alt-v': faArrowsAltV,
  'arrows-from-dotted-line': faArrowsFromDottedLine,
  'arrows-left-right-to-line': faArrowsLeftRightToLine,
  'arrows-to-line': faArrowsToLine,
  'arrows-to-circle': faArrowsToCircle,
  arrows: faArrows,
  asterisk: faAsterisk,
  at: faAt,
  backspace: faBackspace,
  ban: faBan,
  'bars-sort': faBarsSort,
  'bars-staggered': faBarsStaggered,
  'bullseye-pointer': faBullseyePointer,
  bars: faBars,
  bell: faBell,
  bold: faBold,
  bolt: faBolt,
  bookmark: faBookmark,
  'book-atlas': faBookAtlas,
  'book-bookmark': faBookBookmark,
  'book-open': faBookOpen,
  'border-all': faBorderAll,
  'border-outer': faBorderOuter,
  'box-archive': faBoxArchive,
  'box-open': faBoxOpen,
  browser: faBrowser,
  browsers: faBrowsers,
  brush: faBrush,
  bug: faBug,
  'calendar-alt': faCalendarAlt,
  'calendar-circle-exclamation': faCalendarCircleExclamation,
  'calendar-day': faCalendarDay,
  'calendar-range': faCalendarRange,
  'calendar-star': faCalendarStar,
  'calendar-week': faCalendarWeek,
  calendar: faCalendar,
  calculator: faCalculator,
  camera: faCamera,
  'caret-down': faCaretDown,
  'caret-left': faCaretLeft,
  'caret-right': faCaretRight,
  'caret-up': faCaretUp,
  'chart-tree-map': faChartTreeMap,
  'check-circle': faCircleCheck, // TODO old name of icon, but used in key dates icon, so can't change
  check: faCheck,
  'chevron-down': faChevronDown,
  'chevron-up': faChevronUp,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  'circle-half-stroke': faCircleHalfStroke,
  'circle-info': faCircleInfo,
  'circle-notch': faCircleNotch,
  'circle-exclamation': faCircleExclamation,
  'circle-question': faCircleQuestion,
  'circle-user': faCircleUser,
  circle: faCircle,
  clipboard: faClipboard,
  clock: faClock,
  'clock-rotate-left': faClockRotateLeft,
  clone: faClone,
  'cloud-arrow-down': faCloudArrowDown,
  'cloud-arrow-up': faCloudArrowUp,
  code: faCode,
  cog: faCog,
  'columns-3': faColumns3,
  'comment-alt-plus': faCommentAltPlus,
  'comment-plus': faCommentPlus,
  'crop-simple': faCropSimple,
  crown: faCrown,
  'diagram-subtask': faDiagramSubtask,
  diamond: faDiamond,
  'distribute-spacing-horizontal': faDistributeSpacingHorizontal,
  'distribute-spacing-vertical': faDistributeSpacingVertical,
  'draw-circle': faDrawCircle,
  'draw-polygon': faDrawPolygon,
  'draw-square': faDrawSquare,
  edit: faEdit,
  'ellipsis-h': faEllipsisH,
  'ellipsis-v': faEllipsisV,
  envelope: faEnvelope,
  'envelope-circle-check': faEnvelopeCircleCheck,
  'envelope-open': faEnvelopeOpen,
  'exclamation-circle': faCircleExclamation, // TODO old name of icon, but used in key dates icon, so can't change
  'exclamation-triangle': faTriangleExclamation,
  expand: faExpand,
  'external-link': faExternalLink,
  'eye-slash': faEyeSlash,
  eye: faEye,
  'file-chart-pie': faFileChartPie,
  'file-circle-exclamation': faFileCircleExclamation,
  'file-csv': faFileCsv,
  'file-excel': faFileExcel,
  'file-export': faFileExport,
  'file-import': faFileImport,
  'file-image': faFileImage,
  'file-lines': faFileLines,
  'file-pdf': faFilePdf,
  'file-powerpoint': faFilePowerpoint,
  'file-spreadsheet': faFileSpreadsheet,
  'file-dashed-line': faFileDashedLine,
  'file-text': faFileText,
  'file-word': faFileWord,
  files: faFiles,
  'fill-drip': faFillDrip,
  filter: faFilter,
  'filter-slash': faFilterSlash,
  flag: faFlag,
  flask: faFlask,
  'folder-arrow-down': faFolderArrowDown,
  'folder-arrow-up': faFolderArrowUp,
  'folder-gear': faFolderGear,
  'folder-magnifying-glass': faFolderMagnifyingGlass,
  'folder-open': faFolderOpen,
  'folder-plus': faFolderPlus,
  folder: faFolder,
  folders: faFolders,
  'font-case': faFontCase,
  font: faFont,
  gear: faGear,
  'gear-complex-code': faGearComplexCode,
  'globe-pointer': faGlobePointer,
  grid: faGrid,
  'grid-2-plus': faGrid2Plus,
  'grip-dots': faGripDots,
  'grip-lines-vertical': faGripLinesVertical,
  'grip-vertical': faGripVertical,
  handshake: faHandshake,
  hand: faHand,
  hashtag: faHashtag,
  heading: faHeading,
  'hexagon-exclamation': faHexagonExclamation,
  'highlighter-line': faHighlighterLine,
  house: faHouse,
  'i-cursor': faICursor,
  image: faImage,
  indent: faIndent,
  info: faInfo,
  'input-text': faInputText,
  italic: faItalic,
  'layer-group': faLayerGroup,
  'layer-plus': faLayerPlus,
  'line-columns': faLineColumns,
  'link-simple-slash': faLinkSimpleSlash,
  'link-simple': faLinkSimple,
  link: faLink,
  'line-height': faLineHeight,
  'list-ol': faListOl,
  'list-ul': faListUl,
  'list-tree': faListTree,
  loader: faLoader,
  'location-pen': faLocationPen,
  'location-pin-lock': faLocationPinLock,
  lock: faLock,
  'long-arrow-alt-left': faLongArrowAltLeft,
  'long-arrow-alt-right': faLongArrowAltRight,
  'magnifying-glass-minus': faMagnifyingGlassMinus,
  'magnifying-glass-plus': faMagnifyingGlassPlus,
  'magnifying-glass': faMagnifyingGlass,
  'map-marker': faMapMarker,
  'megaphone': faMegaphone,
  'memo': faMemo,
  'memo-circle-info': faMemoCircleInfo,
  'message-captions': faMessageCaptions,
  'microchip-ai': faMicrochipAi,
  'minus-circle': faMinusCircle,
  minus: faMinus,
  'mouse-pointer': faMousePointer,
  'objects-align-bottom': faObjectsAlignBottom,
  'objects-align-center-horizontal': faObjectsAlignCenterHorizontal,
  'objects-align-center-vertical': faObjectsAlignCenterVertical,
  'objects-align-left': faObjectsAlignLeft,
  'objects-align-right': faObjectsAlignRight,
  'objects-align-top': faObjectsAlignTop,
  outdent: faOutdent,
  paperclip: faPaperclip,
  paragraph: faParagraph,
  'pause-circle': faPauseCircle,
  'pen-field': faPenField,
  'pen-slash': faPenSlash,
  pen: faPen,
  'pen-to-square': faPenToSquare,
  'plane-arrival': faPlaneArrival,
  'plane-departure': faPlaneDeparture,
  'plane-up-slash': faPlaneUpSlash,
  'plane-up': faPlaneUp,
  'play-circle': faPlayCircle,
  play: faPlay,
  'plus-circle': faPlusCircle,
  plus: faPlus,
  presentation: faPresentation,
  print: faPrint,
  question: faQuestion,
  'rabbit-running': faRabbitRunning,
  rectangle: faRectangle,
  repeat: faRepeat,
  reply: faReply,
  'rotate-left': faRotateLeft,
  'rotate-right': faRotateRight,
  rotate: faRotate,
  ruler: faRuler,
  save: faSave,
  satellite: faSatellite,
  scribble: faScribble,
  'search-minus': faSearchMinus,
  'search-plus': faSearchPlus,
  search: faSearch,
  shapes: faShapes,
  sidebar: faSidebar,
  'signal-fair': faSignal2,
  'signal-good': faSignal3,
  'signal-slash': faSignalSlash,
  'signal-stream': faSignalStream,
  'signal-strong': faSignal4,
  'signal-weak': faSignal1,
  signal: faSignal,
  'sort-alt': faSortAlt,
  'sort-amount-down': faSortAmountDown,
  sparkles: faSparkles,
  square: faSquare,
  'square-check': faSquareCheck,
  'square-dashed': faSquareDashed,
  'square-dashed-circle-plus': faSquareDashedCirclePlus,
  'square-plus': faSquarePlus,
  'square-question': faSquareQuestion,
  'stamp': faStamp,
  'star-half-alt': faStarHalfAlt,
  star: faStar,
  strikethrough: faStrikethrough,
  swap: faSwap,
  'table-cells': faTableCells,
  table: faTable,
  tag: faTag,
  tasks: faTasks,
  'text-size': faTextSize,
  'text-slash': faTextSlash,
  text: faText,
  'th-large': faThLarge,
  thumbtack: faThumbtack,
  'thumbs-up': faThumbsUp,
  'times-circle': faTimesCircle,
  times: faTimes,
  'toggle-on': faToggleOn,
  trash: faTrash,
  'triangle-exclamation': faTriangleExclamation,
  underline: faUnderline,
  unlink: faUnlink,
  unlock: faUnlock,
  'user-circle': faUserCircle,
  'user-edit': faUserEdit,
  'user-gear': faUserGear,
  'user-plus': faUserPlus,
  user: faUser,
  'users-cog': faUsersCog,
  users: faUsers,
  'wand-magic-sparkles': faWandMagicSparkles,
  'wave-sine': faWaveSine,
  'waveform-lines': faWaveformLines,
  'window-maximize': faWindowMaximize,
  wrench: faWrench,
};

type FaSupportedIconNames = keyof typeof FA_SUPPORTED_ICONS;

export { FA_SUPPORTED_ICONS };
export type { FaSupportedIconNames };
